import React, { useRef, useState, useEffect } from "react";
import { TextInput, Checkbox } from "../form/inputs";
import UploadTriggerCard from "../upload/UploadTriggerCard";
import uploadIcon from "../../assets/images/svgs/other/uploadImg.svg";
import PhotoLibraryModal from "./PhotoLibraryModal";
import { Tooltip } from "react-tooltip";
import { CiCircleInfo } from "react-icons/ci";
import { GoSun } from "react-icons/go";
import { BsMoonStars } from "react-icons/bs";
import ToggleBtn from "../button/ToggleBtn";
import { MdDeleteOutline, MdAdd } from "react-icons/md";
import PrimaryBtn from "../button/PrimaryBtn";
import SecondaryBtn from "../button/SecondaryBtn";
import DecorativeSquares from "../ui/DecorativeSquares";
import { FaArrowLeft } from "react-icons/fa";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  arrayMove,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import SortableImageItem from "../upload/SortablleImageItem";
import toast from "react-hot-toast";

const Addnewmeal = ({ onBack, onSave }) => {
  const [showUploadOptions, setShowUploadOptions] = useState(false);
  const [showLibrary, setShowLibrary] = useState(false);
  const fileInputRef = useRef(null);
  const [showAddInline, setShowAddInline] = useState(false);
  const [mealName, setMealName] = useState("");
  const [description, setDescription] = useState("");
  const currencySymbol = localStorage.getItem("currency");

  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const [dayToggle, setDayToggle] = useState(
    days.reduce((acc, day) => ({ ...acc, [day]: false }), {}),
  );

  const [foodType, setFoodType] = useState(
    days.reduce(
      (acc, day) => ({ ...acc, [day]: { lunch: false, dinner: false } }),
      {},
    ),
  );

  const [serviceImages, setServiceImages] = useState([]);

  useEffect(() => {
    return () => {
      serviceImages.forEach((img) => {
        if (img instanceof File) {
          URL.revokeObjectURL(img);
        }
      });
    };
  }, [serviceImages]);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
    useSensor(TouchSensor, {
      activationConstraint: { delay: 200, tolerance: 5 },
    }),
  );

  // const handloeDragEnd = (event) => {
  //   const { active, over } = event;
  //   if (!over || active.id === over.id) return;

  //   setServiceImages((items) => {
  //     const oldIndex = items.findIndex((i) => i.id === active.id);
  //     const newIndex = items.findIndex((i) => i.id === over.id);
  //     return arrayMove(items, oldIndex, newIndex);
  //   });
  // };

  const handleDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;

    setServiceImages((prev) => {
      const draggedIndex = prev.findIndex((img) => img.id === active.id);
      const overIndex = prev.findIndex((img) => img.id === over.id);

      // Make a copy of the array
      const newArr = [...prev];

      // Remove the dragged item
      const [dragged] = newArr.splice(draggedIndex, 1);

      // Insert it at the new position
      newArr.splice(overIndex, 0, dragged);

      // Ensure the first image is always marked as cover
      newArr.forEach((img, index) => {
        img.isCover = index === 0;
      });

      return newArr;
    });
  };

  const handleDeviceUpload = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const MAX_IMAGES = 10;
    const MAX_SIZE = 5 * 1024 * 1024; // 5MB
    const allowedExtensions = ["jpg", "jpeg", "png", "webp"];

    if (serviceImages.length + files.length > MAX_IMAGES) {
      toast.error("Maximum 10 images allowed");
      e.target.value = "";
      return;
    }

    const validFiles = files.filter((file) => {
      const extension = file.name.split(".").pop().toLowerCase();

      // ✅ Extension validation
      if (!allowedExtensions.includes(extension)) {
        toast.error(
          `${file.name} not supported. Only JPG, JPEG, PNG, WEBP allowed`,
        );
        return false;
      }

      // ✅ Size validation
      if (file.size > MAX_SIZE) {
        toast.error(`${file.name} exceeds 5MB limit`);
        return false;
      }

      return true;
    });

    const withIds = validFiles.map((file) => ({
      id: crypto.randomUUID(),
      file,
    }));

    if (withIds.length) {
      setServiceImages((prev) => [...prev, ...withIds]);
    }

    e.target.value = "";
  };

  const handleOnServiceSave = () => {
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't save`,
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Saved!", "", "success");
        navigate("/profile");
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };
  // Extra Items
  const [extraItems, setExtraItems] = useState([
    { name: "Extra item 1", price: 25 },
    { name: "Extra item 2", price: 25 },
  ]);
  const [newExtra, setNewExtra] = useState({ name: "", price: "" });
  const [showExtraModal, setShowExtraModal] = useState(false);

  const addExtraItem = () => {
    if (!newExtra.name || !newExtra.price) return;

    const newItem = {
      name: newExtra.name,
      price: newExtra.price,
      selected: false,
    };

    setExtraItems((prev) => [...prev, newItem]);

    // reset fields
    setNewExtra({ name: "", price: "" });

    // hide form
    setShowAddInline(false);
  };

  const closeModal = () => {
    setShowExtraModal(false);
    setShowAddInline(false);
    setNewExtra({ name: "", price: "" });
  };

  const deleteExtraItem = (index) => {
    setExtraItems((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSave = () => {
    const mealData = {
      name: mealName,
      description,
      images: serviceImages,
      days: dayToggle,
      foodType,
      extraItems,
    };

    if (typeof onSave === "function") {
      onSave(mealData);
    } else {
      console.warn("onSave function is not provided!");
    }
  };

  return (
    <section className="relative flex justify-center overflow-hidden p-4 lg:bg-gradient-to-br lg:from-orange-50 lg:to-orange-100">
      <DecorativeSquares />
      {/* 🔽 YOUR EXISTING CONTENT */}

      <div className=" max-w-5xl bg-white rounded-2xl shadow-md p-6 space-y-8">
        <div className="relative flex items-center h-10">
          {/* Back Button – Left */}
          <button
            onClick={onBack}
            className="absolute left-0 flex items-center"
          >
            <FaArrowLeft className="text-lg" />
          </button>

          {/* Title – Center */}
          <h1 className="mx-auto text-[#191919] font-bold text-base md:text-lg lg:text-xl">
            Add Meal Plan
          </h1>
        </div>

        {/* ================= Meal Name ================= */}
        <div className="max-w-3xl mx-auto">
          <TextInput
            label="Meal Name"
            name="mealname"
            placeholder="Enter Meal Name"
            value={mealName}
            onChange={(e) => setMealName(e.target.value)}
          />
        </div>

        {/* ================= Upload Meal Photo ================= */}
        <div className="max-w-3xl mx-auto space-y-2">
          <p className="text-sm sm:text-base font-medium">
            Upload Meal Photograph
          </p>
          <UploadTriggerCard
            icon={uploadIcon}
            text="Upload your meal photo or brand image"
            buttonText="Upload"
            onClick={() => setShowUploadOptions(true)}
          />
        </div>

        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          multiple
          className="hidden"
          onChange={handleDeviceUpload}
        />

        {/* ================= Images Preview ================= */}
        {serviceImages.length > 0 && (
          <div className="max-w-5xl mx-auto">
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
            >
              <SortableContext
                items={serviceImages.map((i) => i.id)}
                strategy={rectSortingStrategy}
              >
                <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-6 xl:grid-cols-8 gap-4 touch-none">
                  {serviceImages.map((item, i) => (
                    <SortableImageItem
                      key={item.id}
                      id={item.id}
                      img={item.file}
                      isCover={i === 0}
                      onRemove={() =>
                        setServiceImages((prev) =>
                          prev.filter((_, idx) => idx !== i),
                        )
                      }
                    />
                  ))}
                </div>
              </SortableContext>
            </DndContext>

            <p className="mt-3 text-sm text-gray-600">
              Note: The first image will appear as your cover image.You can
              click and hold to drag images and change their order.
            </p>
          </div>
        )}

        {/* ================= Meal Description ================= */}
        <div className="max-w-5xl mx-auto">
          <TextInput
            label="Meal Description"
            name="description"
            placeholder="Enter Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />
        </div>

        {/* ================= Days & Meal Types ================= */}
        <div className="max-w-5xl mx-auto space-y-6">
          <div className="flex gap-2 items-center mb-2">
            <p className="font-medium">Select Days of Operation</p>
            <CiCircleInfo
              size={18}
              className="cursor-pointer text-gray-400"
              data-tooltip-id="desc-info"
              data-tooltip-content="Select the days and meal types available for your customers."
            />
            <Tooltip
              id="desc-info"
              place="top"
              className="!text-xs !bg-black !px-3 !py-2 !rounded-lg !max-w-[240px] text-center"
            />
          </div>

          {days.map((day) => (
            <div
              key={day}
              className="flex flex-nowrap items-center justify-between md:justify-start bg-gray-50 rounded-lg gap-0 md:gap-4"
            >
              <div>
                <p className="w-16 text-sm">{day}</p>
              </div>

              {/* 3️⃣ Disable checkboxes if toggle is off */}
              <div className="flex gap-2 items-center justify-end flex-wrap">
                <ToggleBtn
                  initial={dayToggle[day]}
                  size={40}
                  onChange={() => {
                    setDayToggle((prev) => {
                      const newValue = !prev[day];

                      // 🔥 Agar toggle OFF ho raha hai → checkbox reset
                      if (!newValue) {
                        setFoodType((ft) => ({
                          ...ft,
                          [day]: { lunch: false, dinner: false },
                        }));
                      }

                      return { ...prev, [day]: newValue };
                    });
                  }}
                />
                <Checkbox
                  variant="pill"
                  label="Lunch"
                  name={`lunch-${day}`}
                  icon={<GoSun />}
                  checked={foodType[day].lunch}
                  disabled={!dayToggle[day]}
                  onChange={(e) =>
                    setFoodType((prev) => ({
                      ...prev,
                      [day]: { ...prev[day], lunch: e.target.checked },
                    }))
                  }
                />

                <Checkbox
                  variant="pill"
                  label="Dinner"
                  name={`dinner-${day}`}
                  icon={<BsMoonStars />}
                  checked={foodType[day].dinner}
                  disabled={!dayToggle[day]}
                  onChange={(e) =>
                    setFoodType((prev) => ({
                      ...prev,
                      [day]: { ...prev[day], dinner: e.target.checked },
                    }))
                  }
                />
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-5xl mx-auto px-3 overflow-hidden">
          <p className="font-medium">Select Days of Operation</p>
          <fieldset className="border rounded-xl p-4 overflow-hidden mt-4">
            <legend className="px-2 text-sm text-gray-700">
              Trial (1 Meal)
            </legend>

            <div className="space-y-2">
              <p className="text-sm text-gray-600">Price</p>

              {/* ONE ROW – NO SIDE SCROLL */}
              <div className="flex items-center  flex-nowrap rounded-lg w-full">
                {/* $ */}
                <div className="px-3 py-2 bg-red-50 text-red-500 font-medium border-r shrink-0">
                  {currencySymbol}{" "}
                </div>

                {/* INPUT */}
                <input
                  type="text"
                  defaultValue={120}
                  className="flex-1 min-w-0 px-2 py-2 w-32 md:w-full outline-none text-sm"
                />

                {/* BADGE */}
                <div className="px-2 py-1 mr-2 bg-red-50 text-red-500 text-[11px] rounded-full whitespace-nowrap shrink-0">
                  {currencySymbol} 120/Order
                </div>
              </div>
            </div>
          </fieldset>
        </div>

        <div className="max-w-5xl mx-auto px-3">
          <fieldset className="border rounded-2xl p-4 mt-4 bg-white">
            <legend className="px-3 text-sm font-medium text-gray-700">
              Weekly
            </legend>

            <div className="space-y-5">
              {[1, 2, 3].map((_, index) => (
                <div key={index} className="space-y-2">
                  <p className="text-sm font-medium text-gray-600">Price</p>

                  {/* ROW */}
                  <div className="flex items-center gap-2 w-full border rounded-xl p-2 overflow-hidden">
                    {/* $ + Price */}
                    <div className="flex items-center gap-1 shrink-0">
                      <div className="px-3 py-2 bg-red-50 text-red-500 font-medium border rounded-md">
                        {currencySymbol}{" "}
                      </div>
                      <input
                        type="text"
                        defaultValue={120}
                        className="w-12 sm:w-24 px-2 py-2 text-center text-sm border border-gray-200 rounded-md outline-none"
                      />
                    </div>

                    {/* Days */}
                    <input
                      type="text"
                      defaultValue={7}
                      className="w-10 sm:w-20 px-2 py-2 text-center text-sm border border-gray-200 rounded-md outline-none shrink-0"
                    />

                    {/* Spacer (IMPORTANT for center alignment) */}
                    <div className="flex-1 min-w-0 flex justify-center">
                      <span className="px-3 py-1 bg-red-50 text-red-500 text-xs font-medium rounded-full whitespace-nowrap">
                        {currencySymbol}120 / Order
                      </span>
                    </div>

                    {/* Delete */}
                    <button className="shrink-0 text-red-500">
                      <MdDeleteOutline size={22} />
                    </button>
                  </div>
                </div>
              ))}
              <button
                type="button"
                className="flex items-center gap-2 text-sm font-medium text-[#FF6943] hover:underline ml-auto"
              >
                <span className="flex items-center justify-center w-3 h-3 border border-[#FF6943] rounded-sm">
                  <MdAdd size={15} />
                </span>
                Add more
              </button>

              <p className="text-[#242021] text-sm sm:text-base text-start max-w-3xl mx-auto">
                Note: Add multiple weekly pricing options if your rates vary by
                the number of days.
              </p>
            </div>
          </fieldset>
        </div>

        <div className="max-w-5xl mx-auto px-3">
          <fieldset className="border rounded-2xl p-4 mt-4 bg-white">
            <legend className="px-3 text-sm font-medium text-gray-700">
              Monthly
            </legend>

            <div className="space-y-5">
              {[1, 2, 3].map((_, index) => (
                <div key={index} className="space-y-2">
                  <p className="text-sm font-medium text-gray-600">Price</p>

                  {/* ROW */}
                  <div className="flex items-center gap-2 w-full border rounded-xl p-2 overflow-hidden">
                    {/* $ + Price */}
                    <div className="flex items-center gap-1 shrink-0">
                      <div className="px-3 py-2 bg-red-50 text-red-500 font-medium border rounded-md">
                        {currencySymbol}
                      </div>
                      <input
                        type="text"
                        defaultValue={120}
                        className="w-12 sm:w-24 px-2 py-2 text-center text-sm border border-gray-200 rounded-md outline-none"
                      />
                    </div>

                    {/* Days */}
                    <input
                      type="text"
                      defaultValue={7}
                      className="w-10 sm:w-20 px-2 py-2 text-center text-sm border border-gray-200 rounded-md outline-none shrink-0"
                    />

                    {/* Spacer (IMPORTANT for center alignment) */}
                    <div className="flex-1 min-w-0 flex justify-center">
                      <span className="px-3 py-1 bg-red-50 text-red-500 text-xs font-medium rounded-full whitespace-nowrap">
                        {currencySymbol}120 / Order
                      </span>
                    </div>

                    {/* Delete */}
                    <button className="shrink-0 text-red-500">
                      <MdDeleteOutline size={22} />
                    </button>
                  </div>
                </div>
              ))}

              <button
                type="button"
                className="flex items-center gap-2 text-sm font-medium text-[#FF6943] hover:underline ml-auto"
              >
                <span className="flex items-center justify-center w-3 h-3 border border-[#FF6943] rounded-sm">
                  <MdAdd size={15} />
                </span>
                Add more
              </button>
              <p className="text-[#242021] text-sm sm:text-base text-start max-w-3xl mx-auto">
                Note: Add multiple Monthly pricing options if your rates vary by
                the number of days.
              </p>
            </div>
          </fieldset>
        </div>

        <div className="max-w-5xl mx-auto px-3">
          <div className="flex gap-2 items-center mb-2">
            <p className="font-medium">Cutoff Time</p>
            <CiCircleInfo
              size={18}
              className="cursor-pointer text-gray-400"
              data-tooltip-id="desc-info"
              data-tooltip-content="Your customer will not be able to place order or cancel order after this cutoff time."
            />
            <Tooltip
              id="desc-info"
              place="top"
              className="!text-xs !bg-black !px-3 !py-2 !rounded-lg !max-w-[240px] text-center"
            />
          </div>
          <div className="flex gap-2 flex-col md:flex-row lg:flex-row">
            <div className="flex flex-col gap-1">
              <label
                htmlFor="lunchTime"
                className="text-sm font-medium text-gray-700"
              >
                Lunch
              </label>

              <div className="flex items-center rounded-lg border border-gray-200 overflow-hidden w-fit">
                {/* Hour Input */}
                <input
                  id="lunchTime"
                  type="text"
                  defaultValue={"2:00"}
                  className="w-14 sm:w-20 px-2 py-2 text-center text-sm outline-none border-r border-gray-200"
                />

                {/* AM / PM */}
                <select className="px-3 py-2 text-sm bg-white outline-none cursor-pointer">
                  <option value="PM" className="p-2">
                    PM
                  </option>
                  <option value="AM" className="p-2">
                    AM
                  </option>
                </select>
              </div>
            </div>

            <div className="flex flex-col gap-1">
              <label
                htmlFor="lunchTime"
                className="text-sm font-medium text-gray-700"
              >
                Dinner
              </label>

              <div className="flex items-center rounded-lg border border-gray-200 overflow-hidden w-fit">
                {/* Hour Input */}
                <input
                  id="lunchTime"
                  type="text"
                  defaultValue={"10:00"}
                  className="w-14 sm:w-20 px-2 py-2 text-center text-sm outline-none border-r border-gray-200"
                />

                {/* AM / PM */}
                <select className="px-3 py-2 text-sm bg-white outline-none cursor-pointer">
                  <option value="PM" className="p-2">
                    PM
                  </option>
                  <option value="AM" className="p-2">
                    AM
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-5xl mx-auto px-3 overflow-hidden">
          <div className="flex gap-2 items-center mb-2">
            <p className="font-medium">Set extra items</p>
            <button
              onClick={() => setShowExtraModal(true)}
              className="flex items-center gap-2 text-sm font-medium text-[#FF6943] hover:underline ml-auto"
            >
              <span className="flex items-center justify-center w-3 h-3 border border-[#FF6943] rounded-sm">
                <MdAdd size={15} />
              </span>
              Add extra item
            </button>
          </div>

          <div className="space-y-2 mt-4">
            {extraItems.map((item, index) => (
              <div
                key={index}
                className={`flex items-center justify-between flex-nowrap px-3 py-2 rounded-lg w-full ${
                  index % 2 === 0 ? "bg-gray-50" : "bg-[#FFFAF8]"
                }`}
              >
                <div className="text-sm font-medium">{item.name}</div>
                <div className="flex gap-4 items-center">
                  <div className="px-2 py-1 text-[#FF6943] font-bold rounded-full whitespace-nowrap shrink-0">
                    {currencySymbol}
                    {item.price}
                  </div>
                  <button
                    onClick={() => deleteExtraItem(index)}
                    className="text-[#FF6943]"
                  >
                    <MdDeleteOutline size={22} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex gap-4">
          <SecondaryBtn
            btnName="Cancel"
            clickEvent={onBack}
            extraClass="-mt-0 w-full"
          />

          <PrimaryBtn btnName="Save Meal Plan" clickEvent={handleSave} />
        </div>
      </div>

      {/* ================= Upload Modal ================= */}
      {showUploadOptions && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl w-80 p-6 space-y-4">
            <h2 className="text-lg font-semibold">Upload Photos</h2>
            <button
              onClick={() => {
                setShowUploadOptions(false);
                fileInputRef.current.click();
              }}
              className="w-full py-2 border rounded-lg hover:bg-gray-50 transition"
            >
              Upload from device
            </button>
            <button
              onClick={() => {
                setShowUploadOptions(false);
                setShowLibrary(true);
              }}
              className="w-full py-2 border rounded-lg hover:bg-gray-50 transition"
            >
              Choose from photo library
            </button>
            <button
              onClick={() => setShowUploadOptions(false)}
              className="w-full text-sm text-gray-400"
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {showLibrary && (
        <PhotoLibraryModal
          onClose={() => setShowLibrary(false)}
          onSelect={(image) => {
            setServiceImages((prev) => [...prev, image]);
            setShowLibrary(false);
          }}
        />
      )}

      {showExtraModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-xl w-full max-w-sm p-4 space-y-4 relative">
            {/* CLOSE BUTTON */}
            <button
              onClick={closeModal}
              className="absolute right-3 top-3 text-gray-500 hover:text-black text-lg"
            >
              ✕
            </button>

            <h2 className="text-lg font-semibold text-center">
              Add Extra Items
            </h2>

            {/* ITEMS LIST */}
            <div className="max-h-64 overflow-y-auto space-y-1">
              {extraItems.map((item, index) => (
                <div
                  key={index}
                  className={`flex justify-between items-center px-3 py-2 rounded ${
                    index % 2 === 0 ? "bg-gray-50" : "bg-[#FFFAF8]"
                  }`}
                >
                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      checked={item.selected || false}
                      onChange={() =>
                        setExtraItems((prev) =>
                          prev.map((el, i) =>
                            i === index
                              ? { ...el, selected: !el.selected }
                              : el,
                          ),
                        )
                      }
                      className="w-4 h-4 accent-green-500"
                    />

                    <span className="text-sm font-medium">{item.name}</span>
                  </div>

                  <span className="text-[#FF6943] font-bold text-sm">
                    {currencySymbol}
                    {item.price}
                  </span>
                </div>
              ))}
            </div>

            {/* ADD NEW ITEM BUTTON */}
            {!showAddInline && (
              <p
                className="text-xs text-center text-[#FF6943] cursor-pointer"
                onClick={() => setShowAddInline(true)}
              >
                Add New Extra Item
              </p>
            )}

            {/* ADD ITEM FORM */}
            {showAddInline && (
              <div className="flex gap-2 items-center mt-2">
                <input
                  type="text"
                  placeholder="Item Name"
                  value={newExtra.name}
                  onChange={(e) =>
                    setNewExtra((prev) => ({
                      ...prev,
                      name: e.target.value,
                    }))
                  }
                  className="flex-1 px-3 py-2 border rounded-md outline-none text-sm"
                />

                <div className="flex items-center border rounded-md px-2 py-1 text-sm">
                  {currencySymbol}
                  <input
                    type="number"
                    value={newExtra.price}
                    onChange={(e) =>
                      setNewExtra((prev) => ({
                        ...prev,
                        price: e.target.value,
                      }))
                    }
                    className="w-12 px-1 py-1 text-right outline-none"
                  />
                </div>

                <button
                  onClick={addExtraItem}
                  className="bg-[#FF6943] text-white px-3 py-2 rounded-md"
                >
                  +
                </button>
              </div>
            )}

            {/* CONFIRM BUTTON */}
            <button
              onClick={closeModal}
              className="w-full bg-[#FF6943] text-white py-2 rounded-lg mt-2"
            >
              Add Items
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Addnewmeal;
